const RETRY_INTERVAL = 250
const MAX_TRIES = 20

let timer = null

export const trustpilotWidget = () => {

	const widgets = document.querySelectorAll('.trustpilot-widget')

	if (!widgets.length) return

	if (window.Trustpilot) {
		widgets.forEach(widget => window.Trustpilot.loadFromElement(widget, true))
		return
	}

	waitForBootstrap()
}

const waitForBootstrap = () => {

	if (timer) return

	let tries = 0

	timer = setInterval(() => {

		if (!window.Trustpilot && ++tries <= MAX_TRIES) return

		clearInterval(timer)
		timer = null

		if (window.Trustpilot) trustpilotWidget()

	}, RETRY_INTERVAL)
}

window.addEventListener('CookiebotOnAccept', () => trustpilotWidget())

export default () => { }
